import React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Chip,
  Box
} from '@mui/material';
import {
  CheckCircle as SuccessIcon,
  Error as ErrorIcon
} from '@mui/icons-material';

function TaskTimeline({ logs }) {
  if (!logs || logs.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary">
          No recent activity
        </Typography>
      </Paper>
    );
  }

  const getStatusIcon = (file) => {
    // Determine status from file name or content
    if (file.file.includes('error') || file.lineCount === 0) {
      return <ErrorIcon color="error" />;
    }
    return <SuccessIcon color="success" />;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  return (
    <Paper sx={{ p: 3 }}>
      <List>
        {logs.map((log, index) => (
          <ListItem
            key={index}
            sx={{
              borderLeft: 3,
              borderColor: log.lineCount > 0 ? 'success.main' : 'error.main',
              mb: 2,
              bgcolor: 'background.default',
              borderRadius: 1
            }}
          >
            <ListItemIcon>
              {getStatusIcon(log)}
            </ListItemIcon>
            
            <ListItemText
              primary={
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="subtitle1">
                    {log.task}
                  </Typography>
                  <Chip
                    label={log.date}
                    size="small"
                    variant="outlined"
                  />
                </Box>
              }
              secondary={
                <Box mt={1}>
                  <Typography variant="body2" color="text.secondary">
                    Modified: {formatDate(log.modified)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Size: {formatFileSize(log.size)} • Lines: {log.lineCount}
                  </Typography>
                  
                  {log.preview && log.preview.length > 0 && (
                    <Box
                      sx={{
                        mt: 1,
                        p: 1,
                        bgcolor: 'grey.100',
                        borderRadius: 1,
                        fontFamily: 'monospace',
                        fontSize: '0.75rem'
                      }}
                    >
                      {log.preview.slice(0, 3).map((line, i) => (
                        <Typography
                          key={i}
                          variant="caption"
                          component="div"
                          sx={{ whiteSpace: 'pre-wrap' }}
                        >
                          {line}
                        </Typography>
                      ))}
                      {log.preview.length > 3 && (
                        <Typography variant="caption" color="text.secondary">
                          ... and {log.preview.length - 3} more lines
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              }
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}

export default TaskTimeline;

